const initialState = {
  language: 'en'
}

function languageReducer (state = initialState, action) {
  switch (action.type) {
    case 'fr':
      return { language: state.language = 'fr' }
    case 'en':
      return { language: state.language = 'en' }
      case "nl":
          return { language: state.language = 'nl' }
    default:
      return state
  }
}

export default languageReducer
